import { ComponentStyleConfig } from "@chakra-ui/react";

const constructRadioStyle = (color: string) => ({
  borderColor: "gray.700",
  _checked: {
    bg: color,
    borderColor: color,
    _hover: {
      bg: "navy.500",
      borderColor: "navy.500",
    },
  },
});

const Radio: ComponentStyleConfig = {
  baseStyle: ({ colorScheme }) => ({
    control: constructRadioStyle(`${colorScheme}.600`),
  }),
};

export default Radio;
